(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function moveBreadcrumb() {
    const webrexBreadcrumb = document.querySelector('.ba-breadcrumb');
    const breadcrumbsContainer = document.querySelector('.breadcrumbs');
    
    if (webrexBreadcrumb && breadcrumbsContainer) {
      const breadcrumbClone = webrexBreadcrumb.cloneNode(true);
      
      breadcrumbsContainer.innerHTML = '';
      breadcrumbsContainer.appendChild(breadcrumbClone);
      breadcrumbsContainer.style.display = 'block';
      
      if (webrexBreadcrumb.parentNode) {
        webrexBreadcrumb.remove();
      }
    } else {
      setTimeout(moveBreadcrumb, 500);
    }
  }
  moveBreadcrumb();
});

  } catch(e) { console.error(e); }
})();
})();
